import { mapValues } from 'lodash-es';

// @ts-expect-error models/rhino is generated in the client application
import { models, modules } from 'models/rhino';
import {
  RhinoAttribute,
  RhinoModuleInfo,
  RhinoResource,
  RhinoResourceProperties
} from '../index';

/* The generated definitions keep what Rhino knows about a model apart from its
 * properties and the query surface it advertises. A resource is addressed as
 * one object everywhere the client reads it, so the three are joined here. */
interface RhinoModelDefinition {
  meta: RhinoResourceProperties;
  properties: Record<string, RhinoAttribute>;
  querySurface?: unknown;
}

const toResource = (definition: RhinoModelDefinition) =>
  ({
    ...definition.meta,
    properties: definition.properties,
    querySurface: definition.querySurface
  }) as RhinoResource;

class ModelLoader {
  resources: Record<string, RhinoResource> = mapValues(
    models as Record<string, RhinoModelDefinition>,
    toResource
  );

  modules: Record<string, RhinoModuleInfo> = modules;
}

export default new ModelLoader();
